import { useCallback, useEffect } from 'react';
import { keys } from '../../Constants/constants';
import { IBoard } from '../../interfaces/WordleInterface';
import { KeyboardContainer } from './styles';

interface Props {
    boardData: IBoard | null;
    handleKeyPress: any
}

const Keyboard = ({ boardData, handleKeyPress }: Props) => {

    const handleKeyboard = useCallback((key: any) => {
        if (key.key === "Enter")
            handleKeyPress("ENTER")
        if (key.key === "Backspace")
            handleKeyPress("⌫")
        if (key.key.length === 1 && key.key.toLowerCase() !== key.key.toUpperCase())
            handleKeyPress(key.key.toUpperCase())
    }, [handleKeyPress])

    useEffect(() => {
        window.addEventListener("keydown", handleKeyboard)

        return () => { window.removeEventListener("keydown", handleKeyboard) }
    }, [handleKeyPress, handleKeyboard])

    return (
        <KeyboardContainer>
            {keys.map((item, index) => (
                <div key={index}>
                    {
                        item.map((key, keyIndex) => (
                            <button key={keyIndex}
                                className={`${boardData && boardData.correctCharArray.includes(key) ? "key-correct" :
                                    (boardData && boardData.presentCharArray.includes(key) ? "key-present" :
                                        boardData && boardData.absentCharArray.includes(key) ? "key-absent" : "")} `}
                                onClick={() => { handleKeyPress(key) }}>
                                {key}
                            </button>
                        ))
                    }
                </div>
            ))}
        </KeyboardContainer>
    );
};

export default Keyboard;
